import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { DroneAreasFormSchema } from 'src/models/drone-areas.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const DroneAreasForm: React.FC<IProp> = ({
  defaultValues = {},
  formRef,
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={DroneAreasFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="2">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_DRONE_AREAS_CITY_LOCATION}
                    name="SensitiveCityLocation"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.SensitiveCityLocation}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="droneAreasId"
                    control={control}
                    error={errors.droneAreasId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default DroneAreasForm;
